import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';

type RotatingIconButtonProps = IconButtonProps & {
  rotated: boolean;
};

/**
 * @param rotated flip the icon upside down (animated)
 */
export const RotatingIconButton = ({ rotated, ...props }: RotatingIconButtonProps) => (
  <IconButton
    sx={{
      transform: !rotated ? 'rotate(0deg)' : 'rotate(180deg)',
      marginLeft: 'auto',
      transition: theme =>
        theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
    }}
    {...props}
  />
);
